export const DRAFT = 'Draft';
export const MSP_REVIEW = 'MSP Review';
export const AWAITING_APPROVAL = 'Awaiting Approval';
export const VENDOR_INVITED = 'Vendor Invited';
export const CANDIDATE_SUBMITTED = 'Candidate Submitted';
export const PRE_SCREEN = 'Pre Screen';
export const CLIENT_REVIEW = 'Client Review';
export const INTERVIEW = 'Interview';
export const OFFER_SUBMITTED = 'Offer Submitted';
export const OFFER_EXTENDED = 'Offer Extended';
export const OFFER_ACCEPTED = 'Offer Accepted';
export const OFFER_REJECTED = 'Offer Rejected';
export const CLOSED = 'Closed';
export const HELD = 'Held';
export const UNHOLD = 'Un Hold';
export const ONBOARDING_PARTIAL = 'Onboarding Partial';
export const ONBOARDING_FINAL = 'Onboarding Final';
export const PLACEMENT_PARTIAL = 'Placement Partial';

export const JobStatus = [
  DRAFT,
  MSP_REVIEW,
  AWAITING_APPROVAL,
  VENDOR_INVITED,
  CANDIDATE_SUBMITTED,
  PRE_SCREEN,
  CLIENT_REVIEW,
  INTERVIEW,
  OFFER_SUBMITTED,
  OFFER_EXTENDED,
  OFFER_ACCEPTED,
  OFFER_REJECTED,
  CLOSED,
  HELD,
  UNHOLD,
  ONBOARDING_PARTIAL,
  ONBOARDING_FINAL,
  PLACEMENT_PARTIAL,
];

export const PendingJobStatus = [MSP_REVIEW, AWAITING_APPROVAL];

export const ActiveJobStatus = [
  VENDOR_INVITED,
  CANDIDATE_SUBMITTED,
  PRE_SCREEN,
  CLIENT_REVIEW,
  INTERVIEW,
  OFFER_SUBMITTED,
  OFFER_EXTENDED,
  OFFER_ACCEPTED,
  OFFER_REJECTED,
  ONBOARDING_PARTIAL,
  ONBOARDING_FINAL,
  PLACEMENT_PARTIAL,
];

export const NotClosedJobStatus = [
  DRAFT,
  MSP_REVIEW,
  AWAITING_APPROVAL,
  VENDOR_INVITED,
  CANDIDATE_SUBMITTED,
  PRE_SCREEN,
  CLIENT_REVIEW,
  INTERVIEW,
  OFFER_SUBMITTED,
  OFFER_EXTENDED,
  OFFER_ACCEPTED,
  OFFER_REJECTED,
  HELD,
  UNHOLD,
  ONBOARDING_PARTIAL,
  ONBOARDING_FINAL,
  PLACEMENT_PARTIAL,
];

export const MspApprovedToastMessage = 'Job (jobId) Approved successfully';
export const BulkMspApprovedToastMessage = 'Jobs Approved successfully';
export const VpApprovedToastMessage = 'Job (jobId) Approved successfully';
export const BulkVpApprovedToastMessage = 'Jobs Approved successfully';
export const ClosedToastMessage = 'Job (jobId) Closed successfully';
export const HeldToastMessage = 'Job (jobId) Held successfully';
export const UnholdToastMessage = 'Job (jobId) Unhold successfully';
export const BulkClosedToastMessage = 'Jobs Closed successfully';
export const BulkHeldToastMessage = 'Jobs Held successfully';
export const BulkUnholdToastMessage = 'Jobs Un-Hold successfully';
